export default "__VITE_ASSET__DWXL910m__"